import { createContext, SetStateAction, Dispatch } from 'react';

import { FormInstance } from 'antd';

import { StepTwoFireForm } from '../../../../interfaces/steps-forms.interface';
import { ActividadesComercio } from '../../../../../../../../../shared/interfaces';

interface StepTwoFormContextProps {
  stepTwoForm:                FormInstance<StepTwoFireForm> | undefined;

  // selectedRubric:          ActividadesComercio | undefined;
  rubricSelected:             ActividadesComercio | undefined;
  setRubricSelected:          Dispatch<SetStateAction<ActividadesComercio | undefined>>;
}

export const StepTwoFormContext = createContext({} as StepTwoFormContextProps);
